import { createFeatureSelector, createSelector } from "@ngrx/store";
import { RoleState } from "./role.state";
import { Role } from "src/app/_models/Role";
import { StoreConstants } from "src/app/constants/StoreConstants";

export const selectRoleState = createFeatureSelector<RoleState>(StoreConstants.STATE_RS);

export const selectGetAdministratorRoles = createSelector(
  selectRoleState,
  (state: RoleState): Role[] => state.list
);